import { LIGHTNING_STRIKE_COLOR, LIGHTNING_STRIKE_INNER_COLOR } from './colors';
import type { LightningGroup } from './types';

/**
 * SPAWN 3, authored in the lightning lab and pasted back.
 *
 * Same rules as ./spawn-1: flat, explicit, replaceable wholesale from a
 * fresh "Copy config" export, and THE LINE IDS ARE NOT COSMETIC -- index.tsx
 * derives each bolt's jag seed from the id's characters, so the two UUIDs
 * below are load-bearing. Renaming them reshapes those bolts.
 *
 * Cut down to the two strands that survived tuning: both fire together at
 * 0.45 and live 0.92, so the group runs 1.37s end to end and is a single
 * paired flash rather than the fan it started as.
 *
 * THE PAIR IS SPLIT BY WHAT HAPPENS AFTER THE BLACKOUT. Both spike to 1 at
 * 0.042; then this first one stays dark from 0.158 all the way to 0.46
 * before a half-strength return, while its partner blinks out later (0.208)
 * and comes back to FULL at 0.558. Same cue, two different recoveries.
 */
export const LIGHTNING_SPAWN_3_GROUP: LightningGroup = {
  id: 'spawn-3',
  name: 'Spawn 3',
  enabled: true,
  position: [0.1, 0.11, 0.06],
  rotationDeg: [0, 2, -6],
  scale: 2,
  lines: [
    {
      id: 'fef3a9b9-0b6d-4dc9-b88b-ffe4ee92af63',
      enabled: true,
      start: [0.09, -0.062, -0.01],
      end: [0.77, 0.278, 0.06],
      delay: 0.45,
      lifetime: 0.92,
      revealSeconds: 0.07,
      brightness: 5.2,
      thickness: 0.00126,
      jag: 0.01,
      detail: 20,
      flickerHz: 16,
      color: LIGHTNING_STRIKE_COLOR,
      innerColor: LIGHTNING_STRIKE_INNER_COLOR,
      keyframes: [
        { time: 0, intensity: 0.5, endOffset: [0, 0, 0] },
        { time: 0.04178571428571428, intensity: 1, endOffset: [0, 0.015, 0] },
        { time: 0.15785714285714286, intensity: 0, endOffset: [0, 0.07, 0] },
        { time: 0.46, intensity: 0, endOffset: [0.01, 0.14, -0.05] },
        { time: 0.65, intensity: 0.5, endOffset: [0.01, 0.14, -0.05] },
      ],
    },
    {
      id: '43edb92a-b6a4-499d-bc59-e288e8a09602',
      enabled: true,
      start: [0.09, -0.092, -0.01],
      end: [0.71, 0.358, 0.01],
      delay: 0.45,
      lifetime: 0.92,
      revealSeconds: 0.07,
      brightness: 5.2,
      thickness: 0.0011,
      jag: 0.01,
      detail: 28,
      flickerHz: 16,
      color: LIGHTNING_STRIKE_COLOR,
      innerColor: LIGHTNING_STRIKE_INNER_COLOR,
      keyframes: [
        { time: 0, intensity: 0.5, endOffset: [0, 0, 0] },
        { time: 0.04178571428571428, intensity: 1, endOffset: [0, 0.015, 0] },
        { time: 0.15785714285714286, intensity: 0.6, endOffset: [0, 0.07, 0] },
        { time: 0.20785714285714285, intensity: 0, endOffset: [0, 0.12, 0] },
        { time: 0.5578571428571428, intensity: 1, endOffset: [0, 0.16, 0] },
      ],
    },
  ],
};
